import { render, staticRenderFns } from "./supAnnoList.vue?vue&type=template&id=7b5475e4&"
import script from "./supAnnoList.vue?vue&type=script&lang=js&"
export * from "./supAnnoList.vue?vue&type=script&lang=js&"
import style0 from "./supAnnoList.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports